// components/Layout/IframeLayout.jsx
import React from "react";
import { Box } from "@mui/material";

const IframeLayout = ({ children }) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
        margin: 0,
        padding: 0,
        overflow: "auto",
        boxShadow: "none",
        border: "none",
      }}
    >
      {children}
    </Box>
  );
};

export default IframeLayout;
